import "../../assets/js/supertabs";
import "bootstrap/js/dist/tab";

import "./careers-new.scss";
import "../shared/news-card";
import "swiffy-slider/css";
import "../shared/job-offer-card/job-offer-card";
import "../shared/cta/cta";

import { 
  appendText,
  getText 
} from "../../assets/js/text-renderer";
import { swiffyslider } from "swiffy-slider";
window.swiffyslider = swiffyslider;

window.addEventListener("load", () => {
  window.swiffyslider.init();
});

window.addEventListener("DOMContentLoaded", async () => {
  if (
    DEVELOPMENT || (
    window["__PRERENDER_INJECTED"] && 
    window["__PRERENDER_INJECTED"].render_text)
  ) await loadText();
});

const loadText = async () => {
  const data = await getText("jobs/landing-carees");
  const content = data.stories[0].content;

  setHeaderContent(content);
  setValuesContent(content);
  setDataTeamContent(content);
  setBenefitsContent(content);
  await setJobOffersContent(content);
  setCTAContent(content);

  window.dispatchEvent(
    new CustomEvent("rendered-text", { detail: "keywords" })
  );
  window.dispatchEvent(
    new CustomEvent("rendered-text", { detail: "content" })
  );
};

function setHeaderContent(content) {
  appendText(content.hero_title, "hero-title");
  appendText(content.hero_description, "hero-description");
};

function setValuesContent(content) {
  appendText(content.values_title, "values-title");
  appendText(content.values_description, "values-description");
  const newCards = document.querySelectorAll("custom-news");

  newCards.forEach((card, index) => {
    const data = content.values_items[index];
    card.setAttribute("data-title", data.title);
    card.setAttribute("data-content", data.text);
    card.render();
  });
};

function setDataTeamContent(content) {
  appendText(content.data_team_title, "data-team-title");
  appendText(content.data_team_content, "data-team-content");
  appendText(content.data_team_cta, "data-team-cta");
};

function setBenefitsContent(content) {
  appendText(content.benefits_title, "benefits-title");

  const benefits = content.benefits_items;
  appendText(benefits[0].title, "benefits-title-0");
  appendText(benefits[1].title, "benefits-title-1");
  appendText(benefits[2].title, "benefits-title-2");
  appendText(benefits[3].title, "benefits-title-3");
  appendText(benefits[4].title, "benefits-title-4");
  appendText(benefits[5].title, "benefits-title-5");
  appendText(benefits[6].title, "benefits-title-6");
  appendText(benefits[7].title, "benefits-title-7");
  appendText(benefits[8].title, "benefits-title-8");
  appendText(benefits[9].title, "benefits-title-9");
  appendText(benefits[10].title, "benefits-title-10");
  appendText(benefits[11].title, "benefits-title-11");

  appendText(benefits[0].description, "benefits-description-0");
  appendText(benefits[1].description, "benefits-description-1");
  appendText(benefits[2].description, "benefits-description-2");
  appendText(benefits[3].description, "benefits-description-3");
  appendText(benefits[4].description, "benefits-description-4");
  appendText(benefits[5].description, "benefits-description-5");
  appendText(benefits[6].description, "benefits-description-6");
  appendText(benefits[7].description, "benefits-description-7");
  appendText(benefits[8].description, "benefits-description-8");
  appendText(benefits[9].description, "benefits-description-9");
  appendText(benefits[10].description, "benefits-description-10");
  appendText(benefits[11].description, "benefits-description-11");
};

async function setJobOffersContent(content) {
  appendText(content.job_offers_title, "job-offers-title");
  appendText(content.job_offers_subtitle, "job-offers-subtitle");

  //Link & Quote
  appendText(content.job_offers[0].title, "job-offer-title-0");
  appendText(content.job_offers[0].richtext, "job-offer-quote-0");
  appendText(content.job_offers[0].text, "job-offer-quote-position-0");

  //Link & Quote
  appendText(content.job_offers[1].title, "job-offer-title-1");
  appendText(content.job_offers[1].richtext, "job-offer-quote-1");
  appendText(content.job_offers[1].text, "job-offer-quote-position-1");

  //Link & Quote
  appendText(content.job_offers[2].title, "job-offer-title-2");
  appendText(content.job_offers[2].richtext, "job-offer-quote-2");
  appendText(content.job_offers[2].text, "job-offer-quote-position-2");

  //Link & Quote
  appendText(content.job_offers[3].title, "job-offer-title-3");
  appendText(content.job_offers[3].richtext, "job-offer-quote-3");
  appendText(content.job_offers[3].text, "job-offer-quote-position-3");

  //Insert job offers
  const keywords = await getText("shared/keywords");
  const jobCardCTA = keywords.stories[0].content.ver_oferta;

  const jobData = await getText("jobs/");
  const jobStories = jobData.stories;
  let consultingOffers = [];
  let dataOffers = [];
  let techOffers = [];
  let practicesOffers = [];

  jobStories.forEach(stories => {
    if(stories.content.component !== "template-job-offer") 
      return;
    else {
      if(stories.content.tag.includes("consulting")) {
        consultingOffers.push(stories);
      }
      if(stories.content.tag.includes("data")) {
        dataOffers.push(stories);
      }
      if(stories.content.tag.includes("technology")) {
        techOffers.push(stories);
      }
      if(stories.content.tag.includes("practices")) {
        practicesOffers.push(stories);
      }
    }
  })

  //Inject title numbers
  const consultingTab = document.getElementById('consultoria-tab');
  const dataTab = document.getElementById('data-tab');
  const techTab = document.getElementById('tecnologia-tab');
  const practicesTab = document.getElementById('practicas-tab');
  const tabs = [consultingTab, dataTab, techTab, practicesTab];

  updateOfferTitleNumber(tabs, consultingOffers, 0);
  updateOfferTitleNumber(tabs, dataOffers, 1);
  updateOfferTitleNumber(tabs, techOffers, 2);
  updateOfferTitleNumber(tabs, practicesOffers, 3);

  //Inject job-offer-cards
  //* If you want to sort the job offers, you can insert the sorting logic here  
  injectJobOfferCards(consultingOffers, "consulting-offers", jobCardCTA);
  injectJobOfferCards(dataOffers, "data-offers", jobCardCTA);
  injectJobOfferCards(techOffers, "tech-offers", jobCardCTA);
  injectJobOfferCards(practicesOffers, "practice-offers", jobCardCTA);
}

function updateOfferTitleNumber(tabs, stories, index) {
  const number = '(' + stories.length + ')';
  
  appendText(number, `job-offer-items-${index}`);

  if(stories.length === 0) {
    tabs[index].classList.add('disabled');
  }
}

function injectJobOfferCards(stories, containerId, cardCTA) {
  const container = document.getElementById(containerId);

  const offersHTML = stories.map((offer) => {
    const offerContent = offer.content;
    return `
      <custom-job-offer-card
        class="p-0"
        benefits='${JSON.stringify(offerContent.benefits)}'
        cta="${cardCTA}"
        description="${offerContent.card_summary}"
        experience="${offerContent.experience}"
        slug="${offer.slug}"
        title="${offerContent.title}"
      ></custom-job-offer-card>
    `;
  }).join('');

  container.insertAdjacentHTML('beforeend', offersHTML);
}

function setCTAContent(content) {
  const customCTAContainer = document.getElementById('custom-cta');
  const ctaData = content.cta[0];
  const customCTA = `
    <custom-cta
      title="${ctaData.title}"
      description="${ctaData.description}"
      primary-button-text="${ctaData.btn_primary}"
      primary-button-url="/nosotros/careers/job/?cod=work-with-us"
    ></custom-cta>
  `;

  customCTAContainer.innerHTML = customCTA;

  window.dispatchEvent(
    new CustomEvent("rendered-text", { detail: "cta" })
  );
}